var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-group",attrs:{"role":"group"}},_vm._l((_vm.values),function(val,key){return _c('button',{class:[_vm.selected==key ? 'btn-primary' : 'btn-default', 'btn'],attrs:{"type":"button"},on:{"click":function($event){return _vm.changeSelectVal(key)}}},[_vm._v(_vm._s(val))])}),0)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6632a94c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/generic/ButtonRadioGroup.vue
// module id = 1025
// module chunks = 6